import { render } from "./PacchettoIbl.vue?vue&type=template&id=b5b8c748&scoped=true&bindings={\"Title\":\"props\",\"BaseFee\":\"props\",\"FinalFee\":\"props\",\"SmallDescription\":\"props\",\"Description\":\"props\",\"PackageId\":\"props\",\"onClickAway\":\"options\",\"goToDetail\":\"options\"}"
import script from "./PacchettoIbl.vue?vue&type=script&lang=js"
export * from "./PacchettoIbl.vue?vue&type=script&lang=js"

import "./PacchettoIbl.vue?vue&type=style&index=0&id=b5b8c748&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5b8c748"

export default script